import { render, staticRenderFns } from "./TableSettingsModal.vue?vue&type=template&id=d9e54806&"
import script from "./TableSettingsModal.vue?vue&type=script&lang=ts&"
export * from "./TableSettingsModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports